export enum UserRoles {
  PA = "PA", //"ProductAnalyst"
  PM = "PM", //"ProductManager"
}

export type User = {
  id: string;
  name: string;
  email: string;
  role: UserRoles;
};

export enum UserActions {
  View = "View",
  Edit = "Edit",
  Approve = "Approve",
  Reject = "Reject",
  Activate = "Activate",
  Deactivate = "Deactivate",
  Delete = "Delete",
  Review = "Review",
  Unlink = "Unlink",
}

export interface UserActionsResponse {
  countries: string[];
  dataLevel: string;
  module: string;
  userRole: UserRoles;
  allowedActions: {
    draft: UserActions[];
    pendingApproval: UserActions[];
    approved: UserActions[];
    rejected: UserActions[];
    active: UserActions[];
    complete: UserActions[];
    deactivated: UserActions[];
  };
}

export enum ERROR_MESSAGES {
  USER_NOT_FOUND = "User not found",
  TOKEN_EXPIRED = "Token expired",
}
